export const UrlsAddress = {
  SupportLink:
    "https://support.freewave.com/hc/en-us/categories/9284914632340-FreeWave-Data-Portal",
};
